import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root"
})
export class SupportService {
  status: number;
  text: string;
  result: string;

  constructor(private http: HttpClient) {}


  createTicket(data: any): Observable<any> {
    let domain = environment.freshdeskConfig.domain;
    let api_key = environment.freshdeskConfig.api_key;
    let url = "https://" + domain + ".freshdesk.com/api/v2/tickets";
    let key = btoa(api_key + ":x");
    let headers = new HttpHeaders()
      .set("Authorization", "Basic " + key)
      .set("Content-Type", "application/json");
    return this.http
      .post(url, JSON.stringify(data), {
        headers: headers
      })
      .pipe(catchError(this.formatErrors));
  }
  private formatErrors(error: any) {
    return throwError(error.error);
  }

  //   getRequestId(error: any) {
  //     let xRequestId;
  //     error.headers._headers.forEach((header: any, key: any) => {
  //       if (key == "x-request-id") {
  //         xRequestId = header[0];
  //       }
  //     });
  //     return xRequestId;
  //   }
}
